import { render, staticRenderFns } from "./integration-callback.vue?vue&type=template&id=c5919368&"
import script from "./integration-callback.vue?vue&type=script&lang=js&"
export * from "./integration-callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports